




















































import Vue, { VNode, VNodeChildren } from "vue";

export default Vue.extend({
  name: "cwx-data-iterator",

  props: {
    //Applies custom classes to the wrapper element around items
    contentClasses: {
      type: String,
      default: "layout row wrap"
    },
    items: {
      type: Array,
      required: true,
      default: []
    },
    //Sets total number of items.
    //Used together with pagination prop to enable server-side sort and pagination.
    totalItems: {
      type: Number,
      default: null
    },
    //The field in the item object that designates a unique key
    itemKey: {
      type: String,
      default: "ideaId"
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    itemsPerPageItems: {
      type: Array,
      default: () => [9, 30, 48, 99]
    },
    prevIcon: {
      type: String,
      default: "icon-chevron-left"
    },
    nextIcon: {
      type: String,
      default: "icon-chevron-right"
    }
  },

  data() {
    return {
      actionsClasses: "cwx-data-iterator__actions",
      actionsSelectClasses: "cwx-data-iterator__actions__select",
      actionsRangeControlsClasses: "cwx-data-iterator__actions__range-controls",
      actionsPaginationClasses: "cwx-data-iterator__actions__pagination"
    };
  },

  computed: {
    itemsLength(): number {
      return this.totalItems || this.items.length;
    },
    getItemsPerPage(): number {
      return this.pagination.itemsPerPage;
    },
    pageStartsWith(): number {
      return (this.pagination.page - 1) * this.getItemsPerPage + 1;
    },
    pageEndsWith(): number {
      const end = this.pagination.page * this.getItemsPerPage;
      return this.itemsLength < end ? this.itemsLength : end;
    }
  },

  created() {
    this.initPagination();
  },

  methods: {
    initPagination(): void {
      this.updatePagination({ page: 1, itemsPerPage: this.getItemsPerPage });
    },
    updatePagination(val: object): void {
      const updatedPagination = Object.assign({}, this.pagination, val);
      this.$emit("update:pagination", updatedPagination);
    },
    changedSelect(val: number) {
      this.updatePagination({
        page: 1,
        itemsPerPage: val
      });
    },
    clickedPrevPage() {
      const page = this.pagination.page;
      this.updatePagination({ page: page - 1 });
    },
    clickedNextPage() {
      const page = this.pagination.page;
      this.updatePagination({ page: page + 1 });
    }
  }
});
